export default {
    "business": {
        "orderTrack": "Shipping Order Tracking",
        "updateTo": "updateTo",
        "exceptionQty": "Number of exceptions",
        "origin": "Departure City",
        "destination": "Destination City",
        "vehicleTeamName": "belonged fleet",
        "billingItemsName": "billing item",
        "source": "source",
        "accidentNumber": "abnormal times",
        "billNumber": "frequency",
        "transIndex": "index",
        "plateNumber": "Plate Number",
        "driverMobile": "driver's phone number",
        "certificateNo": "license number",
        "certificateName": "id type",
        "stationType": "Site type",
        "routeQty": "Waybill Number",
        "locationQty": "Number Of Locations",
        "goodsValue": "Declared Value (THB)",
        "serviceItemName": "service item",
        "jobDescription": "job title",
        "counactEmail": "Email",
        "createdDt": "Start Time",
        "createdDateTime": "Created Date/Time",
        "grade": "level",
        "carloadQuotation": "full truck load or not",
        "billingItemName": "billing item",
        "frequency": "frequency",
        "sourceName": "data source",
        "code": "Code",
        "invokeParam": "trial parameters",
        "ruleCode": "rule code",
        "templateName": "template name",
        "motherTemplateName": "rate card template",
        "lightRatio": "Volume/Weight Ratio",
        "projectName": "service product",
        "editedDt": "change time",
        "editorName": "who modified",
        "lifetimeEnd": "expiration date",
        "lifetimeStart": "effective date",
        "externalContractNo": "external contract number",
        "partnerName": "partner",
        "contractNo": "contract id",
        "quoteType": "type of contract",
        "creatorName": "Create by",
        "creator": "Creator",
        "createMode": "creation type",
        "order": "shipping order",
        "orderNo": "Shipping Order Number",
        "transportNo": "Waybill Number",
        "transportType": "Waybill Type",
        "routeNo": "Dispatch Number",
        "pickUpRouteNo": "Delivery vehicle tracking number",
        "deliverRouteNo": "delivery vehicle number",
        "originNo": "Upstream Tracking Number",
        "businessUnit": "Business Unit",
        "transferNo": "External Tracking Number",
        "shipper": "Shipper",
        "goodsBillNo": "shipment number",
        "shipmentStatus": "Shipment Status",
        "jobStatus": "Job Status",
        "customerSAPCode": "Customer SAP Code",
        "upstreamTrackingNumber": "Upstream Tracking Number",
        "placeholderPresetLine": "Preset Line",
        "customerLineCode": "Customer Line Code",
        "currencyUnit": "Currency Unit",
        "thb": "THB",
        "usDollar": "US Dollar",
        "receiptType": "Receipt Type",
        "note": "Note",
        "deliverNo": "transit order",
        "plan": "plan",
        "planNo": "plan number",
        "taskNo": "task number",
        "bill": "bill",
        "billNo": "bill number",
        "status": "Status",
        "itemTypeSearch": "Item Type, Item code, Keyword",
        "porduct": "shipping product",
        "bizType": "Business Type",
        "paperyReceipt": "Required Receipt",
        "receiptQty": "Number of Receipts",
        "light": "light cargo",
        "temperatureControlName": "Temperature Type",
        "itemTypeCode": "Item Type Code",
        "itemType": "Item Type",
        "lowestTemperature": "Lowest Temperature (℃)",
        "highestTemperature": "Highest Temperature (℃)",
        "keywords": "Keywords",
        "createdDate":"Created Date",
        "updatedDate":"Updated Date",
        "action":"Action",
        "monitorType": "Temperature Type",
        "volume": "Total Volume (cubic meter)",
        "packingQty": "Total Number of Packages",
        "numberOfPackages": "Number of Packages",
        "numberOfItemPerPackages": "Total items",
        "isInsurance": "Cargo Insurance",
        "tempTypeLimit": "Temperature Range",
        "weight": "Total Weight (kg)",
        "goodsQty": "Total Items",
        "vehicleTypeName": "Requested Vehicle Type",
        "goodsDescription": "Item Type Description",
        "goodsCargoDescription": "Item Description",
        "goodsTypeDescription": "Item Type Description",
        "goodsTypeName": "Item Type",
        "goodsTypeNumber": "Item Number",
        "siteName": "Site Code/Name",
        "siteCodeAndName": "Site Code and Name",
        "siteNameOrigin": "Site Code/Name",
        "siteNameDestination": "Site Code/Name",
        "siteNameOriginToolTip": "Origin Site Code/Name",
        "addressOriginToolTip": "Address",
        "addressDestinationToolTip": "Address",
        "contactNumberOriginToolTip": "Contact Number",
        "contactNumberDestinationToolTip": "Contact Number",
        "contactNameOriginToolTip": "Contact Name",
        "contactNameDestinationToolTip": "Contact Name",
        "provinceOriginToolTip": "Province/City/ District",
        "provinceDestinationToolTip": "Province/City/ District",
        "siteNameDestinationToolTip": "Destination Site Code/Name",
        "originSiteCodeAndName": "Origin Information",
        "originShipProvince": "Origin Province",
        "originShipDistrict": "Origin District",
        "originShipSubDistrict": "Origin Sub District",
        "destinationSiteCodeAndName": "Destination Information",
        "destinationShipDistrict": "Destination District",
        "destinationShipProvince": "Destination Province",
        "destinationShipSubDistrict": "Destination Sub District",
        "siteNamePlaceholder": "Please select a site code/name",
        "contactMobile": "Contact Number",
        "contactMobilePlaceholder": "Please enter contact number",
        "contactName": "Contact Name",
        "keyContactPerson": "Key <br> Contact Person",
        "keyContactNumber": "Key <br> Contact Number",
        "provinceDistrictSub_District": "Province/ District/Sub-district",
        "estimateArriveStationDt": "Estimated <br> Arrival Time",
        "estimateLeaveStationDt": "Estimated <br> Departure Time",
        "transitdialogInMark": "Transit <br> Inbound <br> Instructions",
        "transitdialogOutMark": "Outbound <br> Transfer <br> Instructions",
        "requestedVehicleType": "requested vehicle type",
        "actualVehicleType": "Actual Vehicle Type",
        "paidByVehicleType": "Paid by Vehicle Type",
        "assignVehicleType": "Assign Vehicle Type",
        "sameAsRequested": "Same as Requested",
        "differentFromRequested": "Different from Requested",
        "neededLoading": "to be loaded",
        "provinceCityDistrict": "Province/City/ District",
        "addressInfo": "Address Information",
        "originProvince": "originProvince",
        "originCity": "originCity",
        "originDistrict": "originDistrict",
        "startCityDistrict": "start province/city/district",
        "latestDeliveryDt": "Target Pick Up Date/Time",
        "address": "Address",
        "senderAddress": "Shipping Address",
        "receiverAddress": "receiving address",
        "pickupComments": "Pickup Instruction",
        "neededUnloading": "need unloading service",
        "latestReceivedDt": "Target Delivery Date/Time",
        "deliveryComments": "shipping instructions",
        "pickupTotalMarkBool": "Cargo Detail Calculation ( Kilogram , Cubic Meter , Box )",
        "packingGoodsDescription": "cargo description",
        "itemName": "Item Name",
        "packageWidth": "Package Width (m)",
        "packageHeight": "Package Height (m)",
        "packageLength": "Package Length (m)",
        "packageWidth2": "Package Width",
        "packageHeight2": "Package Height",
        "packageLength2": "Package Length",
        "skuCode": "item code",
        "packingUnit": "Packaging Unit",
        "packingVolume": "Volume / package (cubic meter)",
        "packingWeight": "Weight per package(kg)",
        "packageStandard": "packaging specifications",
        "goodsUnit": "unit of goods",
        "packingCloseQty": "number of packaging",
        "orderType": "Document type",
        "checkedPersonName": "confirm person",
        "createRoute": "create a dispatch order",
        "senderCity": "Departure city",
        "senderDistrict": "shipping district",
        "receiverCity": "Destination city",
        "receiverDistrict": "receiving district",
        "originatingSiteCode": "[Origin] Site Code",
        "originatingSiteName": "[Origin] Site Name",
        "destinationSiteCode": "[Destination] Site Code",
        "destinationSiteName": "[Destination] Site Name",
        "destinationProvince": "destination province",
        "destinationCity": "destination city",
        "destinationDistrict": "destination district/county",
        "temperatureControl": "Temperature Control",
        "revokeTransfer": "cancel the transfer",
        "routeInfo": "dispatch information",
        "routeList": "waybill list",
        "routeDetail": "Cargo Information",
        "latestBeginTime": "Target Period",
        "latestEndTime": "required delivery time",
        "routeTransferSave": "dispatch order transfer station settings",
        "noNeededPickupSave": "no pickup transfer point settings",
        "noNeededDeliverySave": "no delivery transfer point settings",
        "pickupTransferSaveHandler": "pickup segment transfer point setting",
        "deliveryTransferSaveHandler": "delivery segment transfer point setting",
        "destinationType": "Destination Type",
        "presetLine": "Preset Line",
        "orderSource": "Shipping Order Source",
        "receiverUser": "[Destination] Contact Name",
        "workAmount": "business volume",
        "rangeReceivedDt": "Target Delivery Time",
        "vehicleDetail": "dispatch information",
        "planBeginDt": "planned departure time",
        "planEndDt": "planned completion time",
        "planDeliveryStartTime": "planned delivery time",
        "planEstimatedTime": "estimated time",
        "planResidenceTime": "estimated receiving handover time",
        "estimatedMileage": "Estimated mileage",
        "planFullLoadRatio": "Full Load Rate",
        "planTonKm": "Estimated ton-kilometers",
        "routeName": "Route Details",
        "lineName": "Line Name",
        "locationGPS": "address locating",
        "addressInformation": "Address Information",
        "workType": "job type",
        "earliestReceivedDt": "Target Delivery Date/Time",
        "autoLine": "automatic planning",
        "fixedLine": "fixed line",
        "destinationSite": "[Destination] Site Name",
        "originatingSite": "[Origin] Site Name",
        "origindistrict": "departure district/county",
        "transportOrderDetail": "Shipping Order Information",
        "inBatchesLabel": "allow batch operation",
        "orderBillingCost": "Approximate Cost",
        "transportationOrderType": "shipping order type",
        "transportDialogTitle": "shipping information at a glance",
        "capacityDriver": "Driver Name",
        "fileName": "file name",
        "vehicleTemperature": "car temperature",
        "routeCarloadQuotation": "vehicle",
        "prebookPickupDt": "appointment pick up time",
        "dispatcherName": "dispatcher",
        "transportStatus": "waybill status",
        "transportExPickupScanDt": "pickup scan time",
        "equipmentNo": "tracker number",
        "pickupRemarks": "pickup notes",
        "actualPackingQty": "number of actual packages",
        "actualVolume": "actual volume (square)",
        "actualGoodsQty": "Actual total items picked up",
        "actualWeight": "picked up weight (kg)",
        "pickupEndDt": "Pickup Completion Time",
        "pickupBeginDt": "pickup start time",
        "pickupArrivalDt": "pickup arrival time",
        "originalWorkAmount": "amount of workload",
        "workRecord": "workload record",
        "transferType": "Transit Type",
        "transferCenterNo": "Transfer order number",
        "transferSiteName": "Transit site",
        "shipperShortName": "Shipper's abbreviation",
        "receivedGoodsTemperature": "Receipt temperature ℃",
        "pickupedGoodsTemperature": "Delivery temperature ℃",
        "toVoid": "void",
        "reCcollectGoods": "retake",
        "transferBill": "transfer order",
        "deliveryDt": "delivery time",
        "affixedCodeType": "label type",
        "deliveryPackingQty": "Number of actual packages",
        "receivablePackingQty": "Number of packages receivable",
        "receiptPackingQty": "Number of packages received",
        "receivableWeight": "Receivable weight (kg)",
        "receivableVolume": "Receivable volume (square)",
        "receiptWeight": "actual weight (kg)",
        "receiptVolume": "Actual volume (square)",
        "deliverPackingQty": "Number of packages to be shipped",
        "damagedPackingQty": "Damaged packages",
        "occurrenceTime": "Generation time",
        "exceptionNo": "exception number",
        "exceptionType": "exception type",
        "exceptionDescription": "exception information",
        "transportExDeliveryEndDt": "Delivery completion time",
        "executeStatus": "execution status",
        "actualMileage": "actual mileage",
        "transportExDeliveryScanDt": "Delivery scan time",
        "totalGoodsQty": "total quantity",
        "totalPackingQty": "Total Number of Packages",
        "missedPackingQty": "Number of missing packages",
        "rejectedPackingQty": "Number of rejected packages",
        "missedGoodsQty": "Total lost items",
        "damagedGoodsQty": "Total damaged items",
        "rejectedGoodsQty": "Total rejected items",
        "receiptGoodsQty": "Total items received",
        "deliveryBeginDt": "Receipt start time",
        "deliveryArrivalDt": "delivery arrival time",
        "prebookDeliveryDt": "reserve delivery time",
        "vehicleTypeNameOfWork": "Actual Vehicle Type",
        "reasonForDifferentVehicle": "Reason for different Vehicle",
        "reasonOfPaidByVehicleType": "Reason of paid by vehicle type",
        "vehicleArrivalDt": "vehicle arrival time",
        "dispatchingDt": "Schedule time",
        "curTime": "Time of occurrence",
        "handleTime": "processing time",
        "confirmTime": "confirmation time",
        "confirmPerson": "Confirm person",
        "personLiable": "Responsible person",
        "rejectedTreatmentMethod": "How to handle rejection",
        "signPersonDt": "Submission time",
        "taskInfo": "Mission information",
        "requiredReceipt": "A paper receipt is required",
        "mobile": "Cell Phone",
        "emailSubject": "Email Subject",
        "neededPickup": "Pickup required",
        "neededDelivery": "Delivery required",
        "vehicleTypeAndNumber": "vehicle Model*Quantity",
        "batchCode": "batch",
        "planRouterTips": "This Waybill is on the current waybill, please select another waybill",
        "reportDataErrTips": "There is an error in the report information. Please improve the report information first",
        "gpsDataLoadingTips": "The tracking data is being refreshed. Please check again later",
        "orderCreatorName": "Created by",
        "noteTakerName": "Note by",
        "backhaul": "Backhaul",
        "distribution": "Distribution",
        "linehual": "Linehual",
        "milkrun": "Milkrun",
        "w2LastMile": "2w Last Mile",
        "w4LastMile": "4w Last Mile",
        "jobNumber": "Job Number",
        "jobNumbers": "Job Number (R)",
        "subContractor": "Subcontractor",
        "vendorSAP": "Vendor SAP Code",
        "childRtoWSL": "Child R to WSL",
        "driverName": "Driver",
        "driverLicenseNumber": "License Number",
        "contactNumber": "Contact Number",
        "surchargeDiscount": "Surcharge/Discount",
        "surchargeDiscountGroup": "Surcharge/\nDiscount Group",
        "surchargeDiscountCode": "Surcharge/Discount Item Code",
        "surchargeDiscountName": "Surcharge/Discount Item Name",
        "routeCode": "Route Code",
        "wslWarehouse": "WSL Warehouse",
        "pleaseSelectWarehouse": "Please select Warehouse",
        "zoneExt": "Zone",
        "routeExt": "Route",
        "vehiclePlateNumber": "Vehicle Plate Number",
        "licensePlateNumber": "License Plate Number",
        "provincialSign": "Provincial Sign",
        "totalWaybillNumber": "Total Waybill Number",
        "actualPickupTime": "Actual Pick Up Time",
        "actualDeliveryTime": "Actual Delivery Time",
        "totalVolumes": "Total Volume (Cube)",
        "actualTotalVolume": "Actual Total Volume (Cube)",
        "actualTotalWeight": "Actual Total Weight (kg)",
        "actualTotalNumberOfPackages": "Actual Total Number of Packages",
        "actualTotalNumberOfItems": "Actual Total Number of Items per Packages",
        "assignBy": "Assign By",
        "actualReceived": "Actual Received",
        "actualReceivedUnit": "Actual Received Unit",
        "actualPaid": "Actual Paid",
        "actualPaidUnit": "Actual Paid Unit",
        "saveBy": "Save by",
        "updatedDateTime": "Updated Date/Time",
        "confirmBy": "Confirm by",
        "confirmDateTime": "Confirm Date/Time",
        "reconciliationStatus": "Reconciliation Status",
        "checkStatus": "Check Status",
        "licensePlateNumber": "License Plate Number",
        "saveJobInformation": "Save Job Information",
        "confirmJobInformation": "Confirm Job Information",
        "doYouWantToSetAllImportedJobInformation":"Do you want to set all imported Job information's Check Status to 'Confirmed'?",
        "confirmJobInformationWarning":"Jobs without Do Ref. will be automatically recorded as <b>SAVE</b> in check Status",
        "importJobInformationsCheckStatusToConfirm":"Import Job information's Check Status is set to 'Confirmed'",
        "importJobInformationsCheckStatusToSave":"Import Job information's Check Status is set to 'Save'",
        "areYouSureYouWantToSaveThisJobInformation": "Are you sure you want to save this job information?",
        "savedSuccessfully": "Saved Successfully",
        "areYouSureYouWantToConfirm": "After confirm job information, this job information can not be edited anymore. Are you sure you want to confirm?",
        "confirmedSuccessfully": "Confirmed Successfully",
        "actualTotalNumberOfPackagesReceived": "Actual Total Number Of Packages Received",
        "actualTotalNumberOfPackagesPaid": "Actual Total Number Of Packages Paid",
        "addServiceItem": "Add Surcharge/Discount Item", 
        "searchbyDiscountItemNameandCode": "Please enter Surcharge/Discount Item Code, Surcharge/Discount Item Name",
        "pleaseenterDiscountName": "Please enter Surcharge/Discount Item Name",
        "pleaseenterDiscountItemcode": "Please enter Surcharge/Discount Item code",
        "note": "Note",
        "packagingUnit": "Packaging Unit",
        "numberOfItemsPerPackages": "Number of items per packages",
        'shippingOrderConfirmation': "Shipping Order Confirmation",
        'wouldYouLikeToConfirmAllImportedShippingOrders': "Would you like to confirm all imported shipping orders?",
        'import_ShippingOrder': "Import_Shipping Order",
        'importShippingOrder': "Import Shipping Order",
        "backToShippingOrder": "Back to Shipping Order",
        "goToSchedule": "Go To Schedule",
        'direct_Schedule_Import': "Direct_Schedule_Import Shipping Order",
        "itemWithAnIssueWillNotBeUploadedAndSaveToTheServer": "Item with an issue will not be uploaded and save to the server. Please solve these issues, and reupload the file.",
        "itemWithAnIssue": "item with an issue.",
        "itemsWithAnIssue": "items with an issue.",
        "itemWithAnIssueShipping": "Item with an issue will not be uploaded and save to the server. Please solve these issues, and reupload the file.",
        "startDateAll": "Start Date : All",
        "endDateAll": "End Date : All",
        "schedule": " Schedule",
        "requiredPickupDate": "Required Pickup Date",
        "requiredDeliveryDate": "Required Delivery Date",
        "downloadTheExcelFileOfTheCurrentSchedule": "Download the Excel file of the current schedule so that you can <br/> update the data and import it in the following stage",
        "downloadExcelFileToPrepareImportFile": "Download excel file to prepare import file <br/> (click Continue if you have already downloaded)",
        "haveBeenUploadAnInformation": "have been uploaded and information \n has been updated.",
        "haveBeenUploadAnInformationTrack": "have been uploaded and information \n has been updated.",
        "haveBeenUploadAnInformationShipping": "have been uploaded and information \n has been updated.",
        "descriptionUploadSuccess": "have been upload and information \n have been updated.",
        "backTo": "Back to",
        "newSchedule": "new schedule.The maximum allow file size is",
        "scheduleTimeStart": "Schedule Time",
        "finish": "Finish",
        "targetPickUpTimeStart": "Target Pick Up Time Start",
        "targetDeliveryTimeStart": "Target Delivery Time Start",
        "actualPickUpTimeStart": "Actual Pick Up Time Start",
        "actualDeliveryTimeStart": "Actual Delivery Time Start",
        "jobInformation": " Job information",
        "importExcelFile": "Download Excel file to prepare import file <br/> (click Continue if you have already downloaded)",
        "importExcelFileRoad": "Download Excel file to prepare import file <br/> ( click Continue if already download excel file )",
        "downloadFileJobDelivered": "Download the Excel file (only \"Job_delivered\") so that you can <br/> update the data and import it in the following stage.",
        "actualPickupDate": "Actual Pick Up Date",
        "actualDeliveryDate": "Actual Delivery Date",
        "fromAll": "From : All",
        "toAll": "To : All",
        "clickToDownload": "Click to Download",
        "continue": "Continue",
        "cancel": "Cancel",
        "operate": "Operate",
        "statuses": "Job Status",
        "clickOrDragFile": "Click or drag file to this area to upload",
        "pleaseUpload": "please upload .xls or .xlsx file from previous step to import",
        "allowFileSize": "new Job information.The maximum allow file size is",
        "totalFileSize": "Total File Size",
        "clickToUpload": "Click to Upload",
        "back": "Back",
        "backTo": "Back to",
        "confirm": "Confirm",
        "quitImport": "Quit Import",
        "confirmQuitImport": "Are you sure you want to quit this import?",
        "unableToImport": "Unable to import",
        "unableToImportShipping": "Unable to import",
        "foundItems": "Found items with an issue uploading",
        "foundItemsShipping": "Found items with an issue uploading",
        "pleaseSolve": "Please solve these issues, and reupload the file.",
        "pleaseSolveShipping": "Please solve these issues, and reupload the file.",
        "itemsUpdatedShipping": "items have been updated.",
        "itemsIssueShipping": "items with an issue.",
        "anIssues": "with an issue.",
        "anUpdated": "without issue.",
        "haveBeenUpload": "have been upload and information",
        "itemsWithoutIssue": "items without issue.",
        "itemWithoutIssue": "item without issue.",
        "itemsWithoutIssueTrack": "items without issue.",
        "itemWithoutIssueTrack": "item without issue.",
        "itemUpdated": "item have been updated.",
        "itemsUpdated": "items have been updated.",
        "issuesItem": "item with an issue.",
        "issuesItems": "items with an issue.",
        "notUploadedAndSave": "Item will not be uploaded and save to the server",
        "itemIssue": "Item with an issue will not be uploaded and save to the server. Please solve these issues, and reupload the file.",
        "download": "Download",
        "reuploadFile": "Reupload File",
        "reuploadFileShipping": "Reupload File",
        "importSuccessfully": "Import successfully",
        "actualCargo": "Actual Cargo information",
        "actualCargoDetail": "Actual Cargo Detail Calculation ( Kilogram , Cubic Meter , Box )",
        "fileTitle": "",
        "targetUpTime": "Target Pick Up Time",
        "weightPerPackage": "Weight per package (kg.)",
        "volumeCubicMeter": "Volume (Cubic Meter)",
        "quantity": "Quantity",
        "doRef": "Do Ref.",
        "farthestStoreCode": "Farthest Store Code",
        "invoiceDate": "Invoice Date",
        "siteInformaion": "Site information",
        "serveVehicleType": "Serve Vehicle Type",
        "trip1":"Trip/001",
        "ton2":"Ton/002",
        "volume3":"Volume/003",
        "bag4":"Bag/004",
        "box5":"Box/005",
        "pack6":"Pack/006",
        "basket7":"Basket/007",
        "pallet8":"Pallet/008",
        "drop9":"Drop/009",
        "crate10":"Crate/010",
        "piece11":"Piece/011",
        "kg12":"Kg/012",
        "km13":"Km/013",
        "trailerType": "Trailer Type",
        "trailerPlateNumber": "Trailer Plate Number",
        "trailerProvincialSign": "Trailer Provincial Sign",
        "trip1":"Trip/001",
        "ton2":"Ton/002",
        "volume3":"Volume/003",
        "bag4":"Bag/004",
        "box5":"Box/005",
        "pack6":"Pack/006",
        "basket7":"Basket/007",
        "pallet8":"Pallet/008",
        "drop9":"Drop/009",
        "crate10":"Crate/010",
        "piece11":"Piece/011",
        "kg12":"Kg/012",
        "km13":"Km/013",
        "removeItemTypeSuccess": "Item Type has been removed",
        "cash": "Cash",
        "trueMoney": "TrueMoney",
        "qrCode": "QR Code",
        "sequence": "Sequence",
        "confirm_document_status":"Verify Document Status",
        "document_confirmed_by":"Verify Document By" ,
        "document_confirmed_date_time": "Verify Document Date/Time",
        "verified" : "Verified",
        "unverified" : "Unverified",
        "no_data" : "No data",
        "total_assigned_driver" : "Total Drivers",
        "addRecord": "Add record",
        "areYouSureYouWantToAddRecord": "Are you sure you want to add record?",
        "recordHaveBeenAdded": "Record have been added",
        "pleaseSearchViewData": "Please Search to view data",
        "selectChildRtoThisPrimaryR":"Select Child R to this Primary R",
        "primaryR": "Primary R",
        "sendToWSL":"Send to WSL",
        "actualWSLProcessTime":"Actual WSL Process Time",
        "errorFromWSL":"Error from WSL"

    },
    "commonTips": {
        "pleaseEnterCustomerLineCode": "Please enter Customer Line Code",
        "sequenceNoPlaceholder": "Please enter sequence",
		"placeholderTransitdialogInMark": "Please enter Transit Inbound Instructions",
		"placeholderTransitdialogOutMark": "Please enter Outbound Transfer Instructions",
        "pleaseSelectTheKeyContactPerson": "Please select the Key Contact Person",
        "pleaseSelectTheKeyContactName": "Please select the Key Contact Number",
        "pleaseSelectSiteCodeName": "Please select a Site Code/Name",
        "pleaseEnterProvinceDistrictSub_District": "Please enter Province, District, Sub-district",
        "enterEstimatedArrivalTime": "Enter Estimated Arrival Time",
        "enterEstimatedDepartureTime": "Enter Estimated Departure Time",
        "billingTipsValidata": "Please enter a reason statement within 2 to 100 words",
        "billingTipsContent": "Reason statement (required, limited to 100 words)",
        "attachmentParameterErrorTips": "the attachment parameter is wrong, please close the pop-up page and try again!",
        "vehicleTypeNameTips": "please enter car model",
        "pleaseEnterDoRef": "Enter Do Ref.",
        "timeRangeTips": "select time range",
        "enterInfoTips": "please fill in the required information before adding the next item",
        "creatorNameTips": "please enter creator",
        "tempRangeTips": "the minimum temperature must be less than the maximum value!",
        "businessPartnerTips": "please enter business partner",
        "refuseTips": "Are you sure to decline?",
        "mustExcelFileTips": "it must be an excel file, it is recommended to download the template first and then fill in!",
        "inputRequired": "required",
        "selectRequired": "required",
        "partnerNameTips": "please select a partner",
        "ruleCodeTips": "please enter the rule code (maximum 32 characters)",
        "ruleTips": "please enter a rule name (maximum 32 characters)",
        "max200": "(maximum 200 characters)",
        "max250": "(maximum 250 characters)",
        "max500": "(maximum 500 characters)",
        "importInformationTips": "import info indication",
        "copyAndPasteTips": "copy successfully, and now you can paste it into excel or a text editor for reference",
        "uploadingTips": "uploading",
        "fileSupportTypeTips": "select file (only support xls or xlsx)",
        "confirmOperation": "whether to confirm the operation?",
        "areYouSureToDelete": "whether to confirm the deletion?",
        "pleaseSelectProjectName": "please select an item",
        "max100": "(maximum 100 characters)",
        "pleaseInputRemark": "please enter a description",
        "pleaseSelectDate": "please select a date",
        "multipleTips": "multiple choice",
        "cancelRouteTransferTips": "whether continue to cancel the transfer",
        "workAmountTips": "please enter business volume",
        "contactNameTips": "Please enter contact name",
        "contactMobileTips": "Please enter contact number",
        "pleaseSelectSiteName": "Please select site code/name",
        "pleaseSelectVehicleType": "Please select vehicle type",
        "cargoOwnerTips": "please enter the customer name",
        "revokeSucceededTips": "withdraw confirmation successful!",
        "pushTips": "upstream tms account push",
        "pleaseInputRouteNo": "please enter the dispatch number",
        "sendSuccess": "sent successfully",
        "routeNoIdNotNullTips": "dispatch id cannot be empty",
        "waybillNoSaveSucceessTips": "waybill sequence saved!",
        "pleaseInputCarrier": "Please enter a carrier",
        "pleaseInputSubcontractor": "Please enter a subcontractor",
        "pleaseSelectSurchargeDiscount": "Please select Surcharge/Discount Group",
        "pleaseEnterReason": "Please enter reason",
        "pleaseSelectDestinationType": "Please select destination type",
        "pleaseSelectRouteCode": "Please select route code",
        "pleaseSelectFarthestStoreCode": "Please select Farthest Store Code",
        "receiveDatasTips": "no invoice",
        "removeRouteTips": "Are you sure you want to remove all waybills under this punctuation?",
        "routerSuccessTips": "dispatch order confirmed successfully",
        "senderAddressStationIdTips": "please enter a shipping address or select a site",
        "senderCityTips": "please enter the shipping city",
        "pleaseInputTransportNo": "please enter the tracking number",
        "capacityTypeCodeTips": "Please enter the model!",
        "capacityDriverMobileTips": "Please enter the driver's phone number!",
        "capacityPlateNoTips": "Please enter the license plate number!",
        "capacityDriverTips": "Please enter a driver!",
        "capacityIdentificationTips": "Please enter your driver's ID!",
        "transferBillTips": "Please enter the transfer order number!",
        "pleaseSelectTransferBill": "Please select a transfer order!",
        "pleaseConfirmGoods": "Please confirm that the goods have been returned to the original storage location!",
        "selectUnit": "Select Unit",
        "waybillNoNotNullTips": "The tracking number cannot be empty!",
        "expressNoTips": "The tracking number format is incorrect!",
        "isConfirmPOD": "Are you sure you want to confirm EPOD/POD?",
        "dataCorrectionWarn": 'Please check and confirm final job’s information in Data Correction',
        "reminder": "Reminder",
        "isConfirmReceipt": "Do you want to confirm the ePOD?",
        "isConfirmPaperReceipt": "whether to confirm the POD",
        "isConfirmReceiptTips": "Do you want to confirm the receipt?",
        "backConfirmDt": "Please select the time to receive the receipt",
        "mobileNumberFormatError": "phone format is incorrect",
        "mobileNumberExist": "Phone number already exists",
        "emailFormatError": "E-mail format is incorrect",
        "emailExist": "Email address already exists",
        "mobileTotalLengthError": "The total length of the entered mobile number cannot exceed 500",
        "isConfirmReanalyze": "Do you want to reconfirm this bill?",
        "transportProductError": "The consignment product is wrong and cannot be synchronized!",
        "ownCarOrIndividualDriverNoTransportProduct": "No checked product/item information for own car or individual driver!",
        "reanalyzeBillSuccess": "Bill recalculation successful!",
        "insuranceValueMustGreaterThanZero": "When the insured value is 'Y', the declared value must be greater than 0!",
        "pleaseSelectOneMessage": "Please select at least one message!",
        "cancelTransitSuccess": "The transfer was cancelled successfully!",
        "transitSuccess": "Dispatch order transfer successfully!",
        "isAddSamePickupAddressWaybill": "Do you want to add the waybill with the same delivery place to the delivery list together?",
        "isFixedRoute": "This operation will fix the data line under the current filter condition, do you want to continue?",
        "pleaseSelectTransitBill": "Please select a dispatch order (only one dispatch order is allowed)",
        "transitBillStatusMustNotClosedOrFinished": "The status of the dispatch order must be non-closed and non-completed.",
        "waybillAppendSuccess": "Waybill added successfully",
        "replanOnlyNewOrUndispatchTransitBill": "Re-planning can only be a new or unscheduled state dispatching order!",
        "isContinueReplan": "Do you want to continue rescheduling the operation?",
        "emailAddressLengthMustLessThan500": "The total length of the entered email address cannot exceed 500",
        "pleaseSelectGroupFieldOrStatisticField": "Please select grouping field or statistics field first!",
        "pleaseSelectField": "Please select a field!",
        "pleaseSelectReportType": "Please select a report type!",
        "pleaseSelectTimeRange": "Please select a time frame!",
        "reportIsGenerating": "The report is being generated!",
        "dateRangeMustLessThan61Days": "Date range cannot exceed 61 days!",
        "uploadImageOnlyJpgPngJpegBmp": "Uploaded pictures can only be in jpg, png, jpeg, bmp format!",
        "uploadImageSizeMustLessThan2Mb": "Upload image size cannot exceed 2MB!",
        "noFileToDownload": "No attachments, no need to pack and download!",
        "trackingDataIsRefreshing": "Tracking data is being refreshed, please check again later!",
        "pleaseSelectBusiness":"Please Select Business Type"
    },
    "error": {
        "validatorError": "you have made a typo, please correct it!",
        "errorMsg": "error message",
        "errorMsgData": "necessary data is missing, please refresh the page and try again!",
        "dataLoadError": "Data loading exception",
        "requireBusinessUnit": "Business Unit is required",
        "validationNumberHighMax": "Please input value higher than {x} and maximum at {y}",
        "validationNumberHighLow": "Please input value higher than {x} and lower than {y}",
    },
    "public": {
        'yes': "Yes",
        'no': "No",
        'areYouSureYouWantToQuitImporting': 'Are you sure you want to quit importing?',
        'quitImporting': 'Quit importing',
        'downloadTemplateMDT': 'Download Template',
        'chooseFile': 'Choose file...',
        'download1': 'Download',
        'theMaximumAllowFileSizeIs': "The maximum allow file size is",
        "totalFileSize": "Total file size",
        'onlyFileFormatIsSupported': "Only .xls or .xlsx file format is supported.",
        'supportedFileFormat': "Only {x} file format is supported.",
        'maxAllowRowText': "The maximum allow : {x} rows",
        'notSupportFileType': "The selected file is not a support file type, please check your file.",
        "clickOrDragFileToUploadShipping": "Click or drag file to this area to upload",
        "clickOrDragFileToUpload": "Click or drag file to this area to upload",
        "dragOrClickToUpload": "Drag a file here or click the button",
        "dragFileOrClick": "Drag a file here or click the button",
        'keywordCannotBeEmpty': 'Keyword cannot be empty',
        'itemTypeCannotBeEmpty': 'Item type cannot be empty',
        "typeCodeCannotBeEmpty": "Type code cannot be empty",
        "download": "Download",
        "name": "name",
        "have": "self-own",
        "loading": "loading",
        "distribution": "city delivery",
        "confirmed": "Confirm",
        "confirmed2": "Confirmed",
        "endDate": "end date",
        "startDate": "start date",
        "edit": "edit",
        "vehicleInfo": "vehicle information",
        "saving": "saving...",
        "serviceInfo": "Service information",
        "qicq": "QQ",
        "wechat": "wechat",
        "male": "Male",
        "female": "Female",
        "userGender": "gender",
        "remove": "remove",
        "validityRange": "validity range",
        "provincCityDistrict": "Province/City/District",
        "provincCityDistrict1": "Province/ District/Sub-district",
        "siteInfo": "Site Information",
        "businessPartner": "Business partner",
        "suspend": "pause",
        "attribute": "attributes",
        "operationLog": "operation record",
        "personnelInfo": "personnel information",
        "carrier": "Subcontractor",
        "partnerAddName": "partner name",
        "baseInfo": "basic information",
        "refuse": "reject",
        "agree": "accept",
        "acceptJobs": "Accept Jobs",
        "postalAddress": "mailing address",
        "offline": "offline",
        "online": "online",
        "shortName": "Short Name",
        "lineNo": "line number",
        "importSuccess": "import successful",
        "no": "No",
        "yes": "Yes",
        "pod": "POD",
        "dayText": "day",
        "hourText": "hour",
        "minuteText": "minute",
        "secondText": "second",
        "weekText": "week",
        "monthText": "month",
        "yearText": "year",
        "epod": "EPOD",
        "all": "All",
        "sequencing": "sequence",
        "shareRule": "apportionment rules",
        "disableSuccess": "disable successfully",
        "enableSuccess": "enabled successfully",
        "enableTips": "Are you sure active?",
        "uploadFail": "upload failed",
        "uploadSuccess": "uploaded successfully",
        "submitTips": "Are you sure to submit?",
        "submitSuccess": "submitted successfully",
        "copyAll": "copy all information",
        "uploadTemplate": "upload template",
        "pass": "pass",
        "noPass": "fail",
        "revoke": "revoke",
        "deConfirm": "anti-confirmation",
        "submit": "submit",
        "deleteSuccess": "successfully deleted",
        "saveSuccess": "successfully saved",
        "saveItemTypeSuccess": "Add Item Type successfully",
        "vehicleHasBeenChanged": "Vehicle has been changed",
        "recalculationSuccess": "recalculation successful",
        "cancelled": "cancelled",
        "editSucceeded": "successfully modified",
        "relationFile": "relevant attachments",
        "contractInfo": "contract information",
        "add": "Create",
        "addItem": "Add",
        "new": "New",
        "newUpperCase": "New",
        "rename": "Rename",
        "modify": "Revise",
        "delete": "Delete",
        "confirm": "Confirm",
        "cancel": "Cancel",
        "enable": "Enable",
        "disable": "Disabled",
        "remove": "Remove",
        "active": "Active",
        "inactive": "Inactive",
        "configure": "Configure",
        "inputRequired": "(required)",
        "selectRequired": "(required)",
        "operation": "Operate",
        "deleteTips": "Are you sure to delete?",
        "deleteItemTypeTitle": "Remove Item Type",
        "deleteItemType": "Are you sure you want to remove Item Type?",
        "disableTips": "Are you sure to inactive?",
        "tips": "hint",
        "operationSuccessful": "done successfully",
        "search": "inquire",
        "save": "Save",
        "preview": "preview",
        "pleaseSelect": "Please choose",
        "pleaseEnter": "Please enter",
        "pleaseNotOnlyOne": "please check at least one data item!",
        "moreShow": "more filter...",
        "moreHide": "collapse filter",
        "maxValue": "maximum value",
        "minValue": "minimum",
        "start": "Start",
        "end": "Finish",
        "noData": "no data",
        "setColumn": "set column",
        "reset": "reset",
        "import": "Import",
        "export": "export",
        "exportData": "Export",
        "exporting": "exporting...",
        "downloadTemplate": "download template",
        "back": "Back",
        "return": "Return",
        "valueAddedServices": "Surcharge / Discount item",
        "valueAddedServices1": "Surcharge / Discount items",
        "notice": "notification",
        "remind": "remind",
        "earlyWarning": "pre-alert",
        "userName": "username",
        "userID": "User ID",
        "trunkLine": "linehaul",
        "dispatch": "schedule",
        "planDispatch": "plan scheduling",
        "pickupGoods": "pick up",
        "noPickupGoods": "not picked up",
        "deliverGoods": "delivery",
        "noDeliverGoods": "undelivered",
        "abnormal": "abnormal",
        "receipt": "receipt",
        "receiptShipper": "shipper's receipt",
        "shipper": "Customer Name",
        "receiptDriver": "driver receipt",
        "driver": "driver",
        "read": "have read",
        "msgInfo": "message content",
        "hour": "hour",
        "minute": "minute",
        "second": "second",
        "log": "log",
        "top": "top",
        "bottom": "bottom",
        "reportName": "report name",
        "date": "date",
        "time": "time",
        "number": "number",
        "title": "title",
        "emailAddress": "email address",
        "empty": "null",
        "line": "route",
        "lng": "longitude",
        "lat": "latitude",
        "latlng": "Latitude, Longitude",
        "startTime": "start time",
        "endTime": "end time",
        "startTimeShip": "Start Time",
        "endTimeShip": "End Time",
        "pleaseNotOnlyOneR": "please select a dispatch record!",
        "pleaseNotOnlyOneT": "please select at least one shipping order record!",
        "warning": "Warning",
        "allSelect": "select all",
        "customerInformation": "Customer Information",
        "shippingInfo": "Delivery Instruction",
        "destinationInfo": "Destination Information",
        "shipToInfo": "Origin Information",
        "cargoInfo": "Cargo Information",
        "individual": "piece",
        "askEndTime": "Request End Time",
        "askStartTime": "Request Start Time",
        "routeAdd": "add to",
        "pushNew": "add to",
        "executing": "in progress...",
        "destinationAddress": "[Destination] Site Name",
        "originAddress": "[Origin] Site Name",
        "planTransportTime": "Planned Shipping Time",
        "subcontractor": "Subcontractor",
        "subcontractorInformation": "Subcontractor Information",
        "downloadDocument": "download documents",
        "shortMessage": "sms",
        "receivingPlace": "Destination Information",
        "deliverGoodsPlace": "Origin Information",
        "saveOrder": "save order",
        "trackEquipment": "tracker",
        "abnormalTemperature": "abnormal temperature",
        "noEquipment": "no equipment",
        "fulload": "fully loaded",
        "pushMore": "add new order",
        "receiptWay": "POD way",
        "pickUpInfo": "pickup information",
        "transportProcessPreview": "Transport process at a glance",
        "sender": "sender",
        "operationError": "operation failed",
        "print": "Print",
        "mapTrack": "map tracking",
        "totalWeight": "Total Weight (kg)",
        "totalVolume": "Total volume (cubic meters)",
        "transportVehicleInfo": "Transport vehicle information",
        "sendInfo": "Shipping Information",
        "returnInfo": "Return Information",
        "transportNoSearch": "Waybill Number Query",
        "routeNoTrack": "Dispatch Order Tracking",
        "overTemperature": "over temperature",
        "billingDetail": "billing information",
        "close": "close",
        "closedTips": "Are you sure to close?",
        "receiverName": "receiverName",
        "oAndtNo": "order number",
        "transportationTrack": "order number",
        "imageOrFile": "photoes/attachment",
        "receiptLable": "received",
        "chooseDateTime": "select date&time",
        "finishTime": "finished time",
        "send": "send",
        "messageContent": "messageContent",
        "optionMode": "handover type",
        "type": "type",
        "createSuccess": "create success",
        "noset": "Unassigned",
        "before": "front",
        "after": "Back",
        "continue": "do you continue",
        "route": "dispatch order",
        "transport": "waybill",
        "systemMsg": "system information",
        "selectPageStyle": "Please select a paper slip style",
        "accountRoleError": "This account is not authorized to access, please log in again",
        "deliveryTypeName": "delivery vehicle model",
        "senderAddressNum": "number of origins",
        "receiverAddressNum": "destination points",
        "need": "need",
        "notNeed": "unnecessary",
        "checkAccountDesc": "Reconciliation Instructions",
        "autoSwitchBillDate": "The business date of this document will not be within the date range of this bill. Do I need to automatically switch to the bill of the corresponding billing period?",
        "selectOrgNode": "Please select the organizational unit node",
        "sureSave": "Are you sure you want to save?",
        "selectType": "Please choose the type",
        "notFixedLine": "not on fixed line",
        "addToFixedLine": "Do these stations need to be added to this fixed line?",
        "electronic_receipt_attachment": "Electronic receipt attachment",
        "sureAutoAdd": "This operation will automatically append the data under the current filter conditions. Do you want to continue?",
        "noMatchRoute": "There is no match to the corresponding dispatch list",
        "removeTransportSuccess": "Remove waybill successfully",
        "sureAutoAddRoute": "This operation will preset the data under the current filter conditions to the line. Do you want to continue?",
        "selected": "checked",
        "mapTips1": "The waybill is represented by lines: the colored ones are \"shipped\", the gray solid lines are \"scheduled\", the gray dotted lines are \"unscheduled\", the circles indicate the origin and destination, and the quadrilaterals indicate",
        "mapTips2": "Transit place, gray figure: place without waybill, colored figure: place with waybill, hollow figure: no waybill, solid figure: with waybill",
        "importAndCheck": "Import & Reconciliation",
        "pleaseSelectCarType": "Please select a car model!",
        "pleaseInputCarNumber": "Please enter the number of cars!",
        "productServiceRequired": "Product/Project Required Services",
        "waybillNotShipped": "The waybill has not been shipped yet!",
        "pleaseInputCurrentPassword": "Please enter your current password.",
        "pleaseInputNewPassword": "Please enter a new password.",
        "pleaseInputConfirmPassword": "Please enter a confirmation password.",
        "newAndOldPasswordCannotBeSame": "The old and new passwords cannot be the same.",
        "twoPasswordNotSame": "The passwords entered twice do not match.",
        "noFeeIdOrBillStatus": "No billing ID or billing status was obtained.",
        "cannotRefreshExtraCapacityAttribute": "Additional capacity attributes cannot be refreshed synchronously.",
        "cannotModify": "Can not be modified!",
        "productServiceMustBeService": "Products/items must be serviced and cannot be modified.",
        "isLoadNextBatchData": "Scrolled to the bottom Do you want to load the next batch of data?",
        "isLoadPreviousBatchData": "Scrolled to the top Do you want to load the last batch of data?",
        "reanalyzeSubmitSuccess": "Reanalysis submitted successfully!",
        "completeCheckSuccess": "Reconciliation completed successfully!",
        "addPointFee": "extra fee",
        "pickupFee": "delivery fee",
        "deliveryFee": "Delivery charges",
        "loadingFee": "Loading fee",
        "unloadingFee": "unloading fee",
        "emptyFee": "emptying fee",
        "totalFee": "total final fee",
        "otherFee": "other fee",
        "waitRecive": "waitRecive",
        "transitAddress": "transitAddress",
        "static": "Static",
        "basicDataLoadFail": "Failed to load data, live after refreshing",
        "dan": "order",
        "shipments": "shipments",
        "car": "car",
        "vehicle": "vehicle",
        "homePage": "Home",
        "switchChangeDrag": "Drag to adjust position",
        "receiptDemandDt": "Demand receipt date",
        "cancelTransitTips": "Do you want to cancel the segment transfer?",
        "cancelBreakTips": "Undo split?",
        "transportbreakTips": "Are you sure to terminate the shipping?",
        "adjustBillingCost": "Adjust fees",
        "workBillingCost": "fees calculated based on operation ",
        "orderBillingCost": "fees on the origin order ",
        "itemType": "the item type",
        "carrierProduct": "the carrier product",
        "originatingSiteType": "type of originating site",
        "destinationSiteType": "type of destination site",
        "carModel": "Requested Vehicle Type",
        "temperatureControl": "Temperature Type",
        "weightKg": "weight (kg)",
        "waybillNumber": "Waybill Number",
        "numberOfSites": "number of sites",
        "unit": "unit",
        "provincialSign": "Provincial Sign",
        "originInformation" : "Origin Information",
        "destinationInformation" : "Destination Information",
        "latitudeLongitude": "Latitude, Longitude",
        "addressInformation": "Address Information",
        "originAddressInformation": "[Origin] Address Information",
        "destinationAddressInformation": "[Destination] Address Information",
        "originLatitudeLongitude": "[Origin] Latitude, Longitude",
        "destinationLatitudeLongitude": "[Destination] Latitude, Longitude",
        "paymentType": "Payment Type",
        "paymentChannel": "Payment Channel",
        "orderPrice": "Order Price",
        "currency": "Currency",
        "paymentStatus": "Payment Status",
        "actualOrderPrice": "Actual Order Price",
        "actualCurrency": "Actual Currency",
        "itemCategory": "Item Category",
        "itemUnitPrice": "Item Unit Price",
        "paymentDetail": "Payment Detail",
        "actualPaymentDetail": "Actual Payment detail",
        "damagedItem": "Damaged Item",
        "enterDamagedItem": "Enter Damaged Item",
        "damagedPackage": "Damaged Package",
        "enterDamagedPackage": "Enter Damaged Package",
        "rejectedItem": "Rejected Item",
        "enterRejectedItem": "Enter Rejected Item",
        "rejectedPackage": "Rejected Package",
        "enterRejectedPackage": "Enter Rejected Package",
        "lostItem": "Lost Item",
        "enterLostItem": "Enter Lost Item",
        "lostPackage": "Lost Package",
        "enterLostPackage": "Enter Lost Package",
        "attachment": "Attachment",
        "image": "Image",
        "proofOfPickup": "Proof of Pickup",
        "proofOfUnloading": "Proof of Unloading",
        "proofOfDelivery": "Proof of Delivery",
        "imageFormat": "(.jpg, .png and .pdf file)",
        "imageFormatSize": "(.jpg, .png and .pdf file, Maximum size is {x} MB)",
        "link": "Link",
        "downloadAll": "Download all",
        "remark": "Remark",
        "writeRemark": "Write the remark...",
        "staffSignature": "Staff Signature",
        "staffName": "Staff Name",
        "staffRole": "Staff Role",
        "latLng": "Latitude , Longitude",
        "information": "Information",
        "reason": "Reason",
        "enterReason": "Enter reason",
        "selectDateTime": "Select Date/Time",
        "uploadImage": "Upload Image",
        "fileSizeExceed": "File size is exceed the allowable limit of {limit} {unit}",
        "siteId": "Site ID",
        "siteCode": "Site Code",
        "siteAddress": "Address",
        "siteName": "Site Name",
        "phoneNo": "Phone No.",
        "accept": "Accept",
        "reject": "Reject",
        "default": "Default",
        "select": "Select",
        "keyContactFirstName": "Key Contract Person 1 First Name",
        "keyContactLastName": "Key Contract Person 1 Last Name",
        "keyContactMobileNo": "Key Contact Person 1 Mobile No.",
        "district": "District",
        "subDistrict": "Sub-District",
        "province": "Province",
        "postalCode": "Postal Code",
        "searchByCustomerAndSite": "Search by Customer name, Site code, Site name, province",
        "enterRemark": "Enter Remark",
        "enterRemarkLimit": "Enter Remark (maximum {n} characters)",
		"remarkLimitError": "Remark must be {n} characters or fewer",
        "noVehicle": "No Vehicle",
        "noDriver": "No Driver",
        "bypass_status": "Bypass Status",
        "the_page_will_be_refreshed_in":"Refreshed in",
        "report_by_job":"Report by Job",
        "job_type":"Job Type",
        "job_created_date_time":"Job Created Date/Time",
        "target_tick_up_date_time":"Target Pick Up Date/Time",
        "report_by_job": "Report by job",
        "report_by_shipment":"Report by shipment",
        "single_shipment": "Single Shipment",
        "multiple_shipment": "Multiple Shipment ",
        "target_pickup_date_time": "Target Pickup Date/Time (From)",
        "please_click":"Please click",
        "to_view_dashboard":"to view Dashboard",
        "jobs": "Jobs",
        "find": "Find",
        "lastUpdated": "Last Updated",
        "shipmentStatus":  "Shipment Status",
        "history":  "History",
        "importLogFilesLimit": "Import log files will no longer be available after {x} days.",
        "returnToShipmentStatus": "Return to Shipment Status",
        "viewImportHistory": "View Import History",
        "fileIsImporting": "File is importing",
        "fileIsImportingBody1": "The process may take time.",
        "fileIsImportingBody2": "Check your import progress at Import list.",
        "pending": "Pending",
        "completed": "Completed",
        "incomplete": "Incomplete",
        "partiallyCompleted": "Partially completed",
        "fileName": "File name",
        "importedDate": "Imported date",
        "importedComplete": "Imported complete",
        "importStatus": "Import status",
        "action": "Action",
        "total": "Total",
        "errorUploadedAndSave": " items with an issue will not be uploaded and save to the server.",
        "pleaseClickToViewMapInformation": "Please <b style='margin-left: 7px; margin-right: 7px; font-style: italic;'>Click</b> to view Map Information"
    },
    "unit": {
        "km": "km.",
        "kg": "kilogram",
        "min": "minute",
        "square": "cubic meter",
        "box": "box",
        "gram": "gram",
        "jin": "catty",
        "gongjin": "kilogram",
        "ton": "ton",
        "gongli": "kilometer",
        "js": "piece",
        "zhan": "station"
    },
    "weekObj": {
        "monday": "monday",
        "tuesday": "tuesday",
        "wednesday": "wednesday",
        "thursday": "thursday",
        "friday": "friday",
        "saturday": "saturday",
        "sunday": "sunday",
        "week": "week"
    },
    "toolTip": {
        "routeCode": "Route Code",
        "unit": "Unit",
        "actualTotalNoPackReceived": "Actual Total Number of Packages Received",
        "actualTotalNoPackPaid": "Actual Total Number of Packages Paid",
        "receivedPackingQtyTips": "Enter Actual Total Number of Packages Received",
        "paidPackingQtyTips": "Enter Actual Total Number of Packages Paid",
        "earliestReceivedDt": "Estimated Arrival Time is required",
        "latestReceivedDt": "Estimated Departure Time is required",
        "contactMobileTips": "Key Contact Number is required",
        "contactNameTips": "Key Contact Person is required",
        "siteNameTips": "Site Code and Name is required",
        "provinceCityDistrictTips": "Province, District, Sub-district is required",
        "addressTips": "Address is required",
        "sequenceTips": "Incorrect Sequence format",
        "keywords": "Each keyword contains a maximum of 10 characters",
        "description":"Description should not over 200 characters"
    },
    "popup": {
        "warning" : "Warning",
        "acknowledge": "Ok",
        "userInformationHasBeenChanged": "User information has been changed. Please log in again"
    },
    "eta":{
        "viewMapDropPoint": "View Map / Drop Point",
        "dropPoint": "Drop Point",
        "target": "Target",
        "targetDropStartDateTime": "Target Drop Start Date/Time",
        "targetDropEndDateTime": "Target Drop End Date/Time",
        "estimated": "Estimated",
        "lastCalculated": "Last calculated : ",
        "estimatedArrivalDateTime": "Estimated Arrival Date/Time",
        "estimatedDepartureDateTime": "Estimated Departure Date/Time",
        "remainingDistance": "Remaining Distance",
        "actual": "Actual",
        "actualConfidenceAndSource": "Distance Confidence : {x}, Distance Source : {y}",
        "actualArrivalDateTime": "Actual Arrival Date/Time",
        "actualDepartureDateTime": "Actual Departure Date/Time",
        "actualDistanceFromOrigin": "Actual Distance from Origin",
        "actualDistanceFromLastDrop": "Actual Distance from Last Drop",
        "planned": "Planned",
        "plannedArriveDateTime": "Planned Arrive Date/Time",
        "plannedDepartureDateTime": "Planned Departure Date/Time",
        "plannedDistanceFromOrigin": "Planned Distance from Origin",
        "plannedDistanceFromLastDrop": "Planned Distance from Last Drop",
        "km": "Km",
        "noMap": "No Map",
        "source":"Source"
        

    }
}



// WEBPACK FOOTER //
// ./src/lang/en.js